import React from 'react';
import MaskedInput from 'react-text-mask';
import TextField from '@material-ui/core/TextField';

function normalizePH(num) {
  // TODO: fix 9 6 gets skipped
  return num;
  if (!num || (typeof num !== 'string' && typeof num !== 'int')) return num;

  num = num.trim();

  if (num.startsWith('+63')) return num.slice(3); // ensure exactly 10 digits after +63
  if (num.startsWith('09')) return num.slice(1);
  if (num.startsWith('63')) return num.slice(2);

  return num;
}

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        '+',
        '6',
        '3',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      placeholderChar="_"
      keepCharPositions
      showMask
      guide
    />
  );
}

const ContactNumberTextField = ({ ...rest }) => {
  const normalizedValue = normalizePH(rest?.value);

  return (
    <TextField
      {...rest}
      value={normalizedValue || ''}
      InputProps={{
        inputComponent: TextMaskCustom
      }}
      InputLabelProps={{ shrink: true }}
    />
  );
};

export default ContactNumberTextField;
